export const scrollToElement = (element: Element, offset = 0) => {
  const boundingBox = element.getBoundingClientRect()

  if (boundingBox) {
    const top = boundingBox.top + window.pageYOffset - offset

    window.scrollTo({ top })
  }
}

export default scrollToElement
